import React from "react";
import { FaLightbulb, FaBriefcase } from "react-icons/fa";

function EnterDeFi() {
  return (
    <>
      <div className="about-style-five-area default-padding">
        <div className="container">
          <div className="text-center">
            <h2 className="title split-text-right split-text-in-right split-lines">
              Enter DeFi Realm with Trading on DEX
            </h2>
            <p>
              Step into the world of decentralized finance (DeFi) by trading on
              a Decentralized Exchange (DEX). Enjoy the freedom to trade
              cryptocurrencies directly from your wallet, without
              intermediaries, and experience the security and transparency of
              blockchain-powered transactions. DEX platforms offer access to a
              variety of DeFi features, including liquidity pools, yield
              farming, and cross-chain trading, all while ensuring privacy and
              lower fees. Empower yourself with full control over your assets as
              you engage in seamless, peer-to-peer trading on the decentralized
              web.
            </p>
          </div>
          <div className="row">
            <div className="col-xl-6 col-lg-5">
              <div className="about-style-five-left-info ">
                <h3>What a DEX offers?</h3>
                <ul className="list-style-two">
                  <li>Smart Contract-Based Transactions</li>
                  <li>Automated Market Maker (AMM)</li>
                  <li>Interoperability with DeFi Protocols</li>
                  <li>On-Chain Order Books (for some DEXs)</li>
                  <li>High Security and Resistance to Hacks</li>
                  <li>Non-Custodial Trading</li>
                  <li>Liquidity Pools</li>
                  <li>Cross-Chain Trading</li>
                  <li>Token Swaps</li>
                  <li>Peer-to-Peer Trading</li>
                  <li>Decentralized Governance</li>
                  <li>Multi-Signature Wallets</li>
                  <li>Low Transaction Fees</li>
                  <li>Privacy and Anonymity</li>
                  <li>Yield Farming and Staking</li>
                </ul>
                <a className="btn btn-style-one mt-30" href="#">
                  Explore More
                </a>
              </div>
            </div>
            <div className="col-xl-5 offset-xl-1 col-lg-7">
              <div className="about-style-five-right-info">
                <ul className="feature-list">
                  <li>
                    <div className="icon">
                      <FaLightbulb size={40} />
                    </div>
                    <div className="info">
                      <h4>Social Media Advancements</h4>
                      <p>
                        AI is advancing fields that offer exciting chance for
                        modern innovation.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <FaBriefcase size={40} />
                    </div>
                    <div className="info">
                      <h4>Entrepreneur Opportune</h4>
                      <p>
                        AI is advancing fields that offer exciting chance for
                        modern innovation.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EnterDeFi;
